import {
  ProjectOrderByColumnEnum,
  ProjectsWhereColumn,
  type ProjectTemplateFragment,
  ProjectTemplatesDocument,
  type ProjectTemplatesQuery,
  type ProjectTemplatesQueryVariables,
  SortOrder,
  SqlOperator,
} from "@src/__generated__/graphql";
import { FetchHelper } from "@src/helpers/apollo/fetch";
import { Filter, Filters } from "@src/utils/components/filters/models";
import { OrderBy } from "@src/utils/components/sorting/OrderBy";
import { PaginationState } from "@src/utils/mobx/states/PaginationState";
import { action, makeObservable, observable } from "mobx";

export class CreateProjectMenuStore {
  readonly storeKey = "create-project-menu-store";

  fetcher = new FetchHelper<
    ProjectTemplatesQuery,
    ProjectTemplatesQueryVariables
  >(ProjectTemplatesDocument);
  pagination = new PaginationState(this.storeKey, {
    page: 0,
    onChangePagination: (state) => {
      this.fetchData(state.asParams);
    },
  });
  where = new Filters<ProjectsWhereColumn>([
    new Filter({
      column: ProjectsWhereColumn.IsTemplate,
      options: [],
      operator: SqlOperator.Eq,
      value: "true",
      hidden: true,
    }),
  ]);
  orderBy = new OrderBy<ProjectOrderByColumnEnum>([
    { column: ProjectOrderByColumnEnum.ProjectCode, order: SortOrder.Asc },
  ]);

  @observable currentTemplateIds = new Set<string>();
  @observable projectTemplates: ProjectTemplateFragment[] = [];

  constructor() {
    makeObservable(this);
  }

  @action.bound async fetchData(pagination: PaginationState["asParams"]) {
    const [data, error] = await this.fetcher.fetch({
      filters: {
        orderBy: this.orderBy.asWhereParam,
        where: this.where.asWhereParam,
      },
      first: pagination.first,
      page: pagination.page + 1,
    });

    if (error || !data?.projects) return;

    for (const template of data.projects.data) {
      if (this.currentTemplateIds.has(template.id)) continue;
      this.projectTemplates.push(template);
      this.currentTemplateIds.add(template.id);
    }

    this.pagination.setFromPaginatorInfo(data.projects.paginatorInfo);
  }
}
